<template>
  <TourOverlay v-if="!isMobile" />
  <component :is="'div'" v-if="maintenanceMode" class="tw:bg-[#f9fafa] tw:h-screen tw:w-screen">
    <MaintenanceMode />
  </component>
  <component v-else :is="$route.meta.layout || 'div'" :class="getBackgroundColor">
    <RouterView></RouterView>
  </component>
</template>
<script setup>
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { useIsMobile } from './composables/useIsMobile'

import MaintenanceMode from '@/views/MaintenanceView.vue'
import TourOverlay from './components/rateConnect/tour/TourOverlay.vue'

const route = useRoute()
const { isMobile } = useIsMobile()
const maintenanceMode = import.meta.env.VITE_IS_MAINTENANCE_MODE === 'true'

const getBackgroundColor = computed(() => {
  if (route.name === 'studio-plus-compare') return 'tw:bg-white'
  else if (route.name === 'home') return 'tw:bg-gray-200'
  else return 'tw:bg-[#f9fafa]'
})
</script>
